'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.batchDeclarations = undefined;

var _ramda = require('ramda');

var _ramdaAdjunct = require('ramda-adjunct');

var _breakpointMapping = require('../utils/breakpointMapping');

var foundMatch = (0, _ramda.flip)(_ramda.gte)(0);

var findBatchIndex = function findBatchIndex(batches, _ref) {
  var name = _ref.name,
      query = _ref.query;

  var result = (0, _ramda.findIndex)((0, _ramda.both)((0, _ramdaAdjunct.lensEq)(_breakpointMapping.lName, name), (0, _ramdaAdjunct.lensEq)(_breakpointMapping.lQuery, query)), batches);
  return result;
};

var createNewBatch = function createNewBatch(breakpointMapping, batches) {
  return (0, _ramda.append)(breakpointMapping, batches);
};

var addToBatch = function addToBatch(_ref2) {
  var name = _ref2.name,
      query = _ref2.query,
      value = _ref2.value;
  return (0, _ramda.pipe)(_breakpointMapping.propValue, (0, _ramdaAdjunct.concatRight)(value), (0, _breakpointMapping.createBreakpointMapping)(name, _ramda.__, query));
};

// eslint-disable-next-line import/prefer-default-export
var batchDeclarations = exports.batchDeclarations = (0, _ramda.reduce)(function (batches, breakpointMapping) {
  var matchedIndex = findBatchIndex(batches, breakpointMapping);
  return foundMatch(matchedIndex) ? (0, _ramda.over)((0, _ramda.lensIndex)(matchedIndex), addToBatch(breakpointMapping), batches) : createNewBatch(breakpointMapping, batches);
}, []);


//////////////////
// WEBPACK FOOTER
// ./~/cssapi/lib/utils/declarations.js
// module id = 681
// module chunks = 168707334958949